export default __webpack_public_path__ + "static/media/Frame28.029eb58b.png";